angular.module('natgeo').directive('nextButton', function()
{
  var controller = ['$scope', '$element', 'container', 'ScreenView',
  function NextButton($scope, element, container, ScreenView)
  {
    // Scale the element!
    element.scale( container.getScale() );

    // Default ngNext
    if ( !element.attr('ng-next') )
    {
      $scope.ngNext = $scope.$parent.next;
    }

    // Default named
    if ( element.attr('ng-named') )
    {
      element.data('named', element.attr('ng-named') );
    }
  }];

  return {
    templateUrl: 'templates/next-button.html',
    restrict: 'E',
    replace: true,
    scope: {
      ngNext: '&',
      ngNamed: '@'
    },
    controller: controller
  };
});